import {Droppable, DroppableProps} from '@hello-pangea/dnd';
import React, {FC, ReactElement, ReactNode} from 'react';

export interface DropProps extends Omit<DroppableProps, 'children'> {
  children: ReactNode;
}

export const Drop: FC<DropProps> = ({droppableId, children, type, ...props}): ReactElement => {
  return (
    <Droppable droppableId={droppableId} type={type}>
      {(provided) => {
        return (
          <div ref={provided.innerRef} {...provided.droppableProps} {...props}>
            {children}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};
